import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ProductInventory extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInventory);
    this.updateDeliveryDate();
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  /**
   * Updates the inventory.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateInventory = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const selector = this.classList.contains('iurop-stock-indicator')
      ? 'product-inventory.iurop-stock-indicator'
      : 'product-inventory:not(.iurop-stock-indicator)';
    const newInventory = event.detail.data.html.querySelector(selector) || event.detail.data.html.querySelector('product-inventory');

    if (!newInventory) return;

    morph(this, newInventory, { childrenOnly: true });
    this.updateDeliveryDate();
  };

  updateDeliveryDate() {
    const container = this.matches('.iurop-stock-indicator') ? this : this.querySelector('.iurop-stock-indicator');
    if (!(container instanceof HTMLElement)) return;

    const dateElement = container.querySelector('.iurop-stock-indicator__delivery-date');
    if (!(dateElement instanceof HTMLElement)) return;

    const region = container.dataset.region || 'peninsula';
    const now = new Date();
    const currentHour = now.getHours();
    const shippingDate = new Date(now);

    if (currentHour >= 12) {
      shippingDate.setDate(shippingDate.getDate() + 1);
    }

    while (shippingDate.getDay() === 0 || shippingDate.getDay() === 6) {
      shippingDate.setDate(shippingDate.getDate() + 1);
    }

    let minBusinessDays = 1;
    let maxBusinessDays = 3;

    switch (region) {
      case 'europe':
        minBusinessDays = 3;
        maxBusinessDays = 3;
        break;
      case 'canarias':
      case 'world':
        minBusinessDays = 7;
        maxBusinessDays = 7;
        break;
      default:
        minBusinessDays = 1;
        maxBusinessDays = 3;
    }

    const addBusinessDays = (startDate, businessDays) => {
      const result = new Date(startDate);
      let added = 0;

      while (added < businessDays) {
        result.setDate(result.getDate() + 1);
        if (result.getDay() !== 0 && result.getDay() !== 6) {
          added++;
        }
      }

      return result;
    };

    const deliveryStartDate = addBusinessDays(shippingDate, minBusinessDays);
    const deliveryEndDate = addBusinessDays(shippingDate, maxBusinessDays);

    const dayNames = ['domingo', 'lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
    const monthNames = [
      'enero',
      'febrero',
      'marzo',
      'abril',
      'mayo',
      'junio',
      'julio',
      'agosto',
      'septiembre',
      'octubre',
      'noviembre',
      'diciembre',
    ];

    const startDayNumber = deliveryStartDate.getDate();
    const startMonthName = monthNames[deliveryStartDate.getMonth()];
    const endDayName = dayNames[deliveryEndDate.getDay()];
    const endDayNumber = deliveryEndDate.getDate();
    const endMonthName = monthNames[deliveryEndDate.getMonth()];

    if (minBusinessDays === maxBusinessDays) {
      dateElement.textContent = `${endDayName} ${endDayNumber} de ${endMonthName}`;
      return;
    }

    if (deliveryStartDate.getMonth() === deliveryEndDate.getMonth()) {
      dateElement.textContent = `del ${startDayNumber} al ${endDayNumber} de ${endMonthName}`;
      return;
    }

    dateElement.textContent = `del ${startDayNumber} de ${startMonthName} al ${endDayNumber} de ${endMonthName}`;
  }
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}
